import React from 'react';
import { Box, Card, Grid, Icon, IconButton, styled, Tooltip } from '@mui/material';
import { Small } from '@components/Typography';
import { Typography } from 'antd';

const StyledCard = styled(Card)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '24px !important',
  background: theme.palette.background.paper,
  [theme.breakpoints.down('sm')]: { padding: '16px !important' }
}));

const ContentBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  '& small': { color: theme.palette.text.secondary },
  '& .icon': { opacity: 0.6, fontSize: '50px', color: theme.palette.primary.main }
}));

const Heading = styled('h6')(({ theme }) => ({
  margin: 0,
  marginTop: '4px',
  fontSize: '16px',
  fontWeight: '500',
  color: theme.palette.primary.main
}));
const TextValue = styled('h6')(({ theme }) => ({
  margin: 0,
  marginTop: '4px',
  fontSize: '20px',
  fontWeight: '500',
  color: theme.palette.primary.main
}));

const StatCards = ({ deviceList }) => {
  const totalDevices = deviceList?.length ?? 0;
  const totalOnline = deviceList?.filter(function (item) {
    return (
      (Number(Date.now()) - Number(item.last_seen_at)) / 1000 <=
      Number(JSON.parse(item['/84/0']).reportPeriod) + 60
    );
  }).length;
  const totalOffline = deviceList?.filter(function (item) {
    return (
      (Number(Date.now()) - Number(item.last_seen_at)) / 1000 >
      Number(JSON.parse(item['/84/0']).reportPeriod) + 60
    );
  }).length;
  const cardList = [
    { name: 'Total Devices', total: totalDevices, icon: 'access_time' },
    { name: 'Number Online', total: totalOnline, icon: 'online_prediction' },
    { name: 'Number Offline', total: totalOffline, icon: 'portable_wifi_off' }
  ];

  return (
    <Grid container spacing={3} sx={{ mb: '24px' }}>
      {cardList.map((item, index) => (
        <Grid item xs={12} md={4} key={index}>
          <StyledCard elevation={4}>
            <ContentBox>
              <Icon className="icon">{item.icon}</Icon>
              <Box ml="18px">
                <Heading sty>{item.name}</Heading>
                <TextValue>{item.total}</TextValue>
              </Box>
            </ContentBox>
          </StyledCard>
        </Grid>
      ))}
    </Grid>
  );
};

export default StatCards;
